import { theme } from '../AppThemeProvider/AppThemeProvider';

export const stringCellStyles = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: '1.2',
  whiteSpace: 'normal',
};

export const clickableCellStyle = {
  ...stringCellStyles,
  color: theme.palette.primary.main,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};
